module.exports = __webpack_public_path__ + "assets/img/warrior-name-57a8f6f9.png";